<template>
    <v-card-text class="mt-4">
        <v-row no-gutters class="mb-2">
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-form ref="form">

                <v-row no-gutters>
                    <v-col cols="4">
                        <v-btn class="my-1" color="primary" @click="exportar()">
                            <v-icon left>mdi-microsoft-excel</v-icon> Exportar
                        </v-btn>
                        <v-btn
                            class="ml-2 my-1"
                            color="primary"
                            @click="importar()"
                        >
                            <v-icon left>mdi-plus-thick</v-icon> Importar
                        </v-btn>
                    </v-col>
                    <v-col cols="8">
                        <v-file-input
                            label="Arquivo CSV"
                            outlined
                            dense
                            v-model="arquivoCSV"
                            :rules="regra.csv"
                            accept=".csv"
                        ></v-file-input>
                    </v-col>
                </v-row>
                </v-form>
                
                
            </v-col>
        </v-row>
        <v-expand-transition>
            <div v-show="erro">
                <v-row no-gutters class="mb-2">
                    <v-col cols="6">
                        <download-csv
                            :data="erros"
                            :labels="errosLabels"
                            name="erros.csv"
                            delimiter=";"
                        >
                            <v-btn color="primary">
                                <v-icon left>mdi-microsoft-excel</v-icon>
                                Exportar Erros
                            </v-btn>
                        </download-csv>
                    </v-col>
                </v-row>
                <v-data-table
                    :headers="headerErros"
                    :items="erros"
                    :items-per-page="5"
                    :options.sync="paginationErros"
                    :footer-props="tableConfig"
                    class="elevation-0 data-table-2 tabela"
                ></v-data-table>
            </div>
        </v-expand-transition>
        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        
    </v-card-text>
</template>

<script>
export default {
    name: 'Filiais',
    data() {
        return {
            busca: '',
            dialogoExcluir: false,
            headers: [
                {
                    text: 'Id Java',
                    value: 'id_java',
                    align: 'center',
                    class: 'th-separador',
                },
                {
                    text: 'Nome',
                    value: 'nome',
                    align: 'center',
                    class: 'th-separador',
                },
                { text: 'Ações', value: 'acoes', align: 'center', with: '1%' },
            ],
            filiais: [],
            pagination: {},
            carregando: false,
            headerErros: [
                { text: 'Descrição do Erro', value: 'msg', align: 'left' },
            ],
            tableConfig: {
                itemsPerPageOptions: [5,10, 15, 25, 50, 100],
                itemsPerPageText: 'Linhas por páginas',
                ofText: 'de',
                pageText: '{0}-{1} de {2}',
            },
            erros: [],
            errosLabels: { msg: 'Descrição do Erro' },
            erro: false,
            paginationErros: {},
            arquivoCSV: null,
            filialExclusao: null,
            regra: {
                csv: [
                    (v) => !!v || 'Selecione um arquivo.',
                    (v) =>
                        (!!v && ['.csv', '.CSV'].includes(v.name.substr(-4))) ||
                        'O arquivo deve ser do tipo CSV.',
                ],
            },
            isCsv: false,
        }
    },
    watch: {
        usuario(newUsuario, odlUsuario) {
            // console.log(newUsuario,odlUsuario)
            this.limpeErros()
            this.buscar()
        },
    },
    methods: {
        async exportar() {
            this.carregando = true
            this.pagination.page = 1
            let data = { exportar: true }
            var response = await this.$http().post(
                '/usuario/filiais/exportar',
                { data }
            )
            window.location = this.$http('baseURL') + response.data.url
            this.carregando = false
        },
        limpeErros() {
            this.headerErros = [
                { text: 'Descrição do Erro', value: 'msg', align: 'left' },
            ]
            this.erros = []
            this.errosLabels = { msg: 'Descrição do Erro' }
            this.erro = false
            this.paginationErros = {}
        },
        async importar() {
            // valida se o arquivo foi selecionado
            if (!this.arquivoCSV) {
                this.$dialog.notify.error('Selecione um arquivo.', {
                    position: 'top-right',
                    timeout: 5000,
                })
                return
            }
            this.carregando = true

            this.limpeErros()

            // var data = { id_usuario: this.usuario.id_usuario }

            var formData = new FormData()

            formData.append('files', this.arquivoCSV)
            // formData.append('data', JSON.stringify(data))

            this.arquivoCSV = null

            try {
                this.$refs.form.resetValidation()
            } catch (error) {
                //console.log(error)
            }

            var response = await this.$http().post(
                '/usuario/filiais/importargeral',
                formData
            )

            this.carregando = false

            if (!response.data.sucesso) {
                // this.buscar();
                this.erros = response.data.erros
                this.pagination.page = 1
                this.erro = true
            } else {
                this.$emit("fecharRegional");
            }
            
        },
    },
}
</script>

<style>
.ajusteBotoes {
    display: flex;
    flex-direction: column;
    align-content: space-around;
}
</style>